// Auto-generated by scripts/writeBuildGitSha.js — do not edit
export default "1ef5d98";
